<div
  class="l2fa-overlay"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'l2fa-title-' + portal"
  (click)="onBackdropClick($event)"
>
  <div class="l2fa-modal" [class.l2fa-modal--customer]="portal === 'customer'" [class.l2fa-modal--seller]="portal === 'seller'">
    <button type="button" class="l2fa-close" (click)="back.emit()" [disabled]="loading" aria-label="Back to login">
      ×
    </button>

    <header class="l2fa-header">
      <div class="l2fa-icon" aria-hidden="true">
        <ion-icon [name]="requiresAuthenticator ? 'phone-portrait-outline' : 'shield-checkmark-outline'"></ion-icon>
      </div>
      <p class="l2fa-eyebrow">{{ portal === 'seller' ? 'Seller account' : 'Customer account' }}</p>
      <h2 class="l2fa-title" [id]="'l2fa-title-' + portal">
        {{ requiresAuthenticator ? 'Authenticator code' : 'Two-factor verification' }}
      </h2>
      <p class="l2fa-desc">
        @if (requiresAuthenticator) {
          Enter the 6-digit code from your authenticator app to finish signing in.
        } @else {
          Enter the 6-digit code we sent to your email to finish signing in.
        }
      </p>
      @if (maskedEmail) {
        <div class="l2fa-email">
          <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
          <span>{{ maskedEmail }}</span>
        </div>
      }
    </header>

    @if (errorMessage) {
      <div class="l2fa-alert" role="alert">
        <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
        <span>{{ errorMessage }}</span>
      </div>
    }

    <form (submit)="submit(); $event.preventDefault()">
      <label class="l2fa-label" for="l2fa-digit-0">Verification code</label>
      <div class="l2fa-digits" role="group" aria-label="6-digit verification code">
        @for (digit of digits; track $index; let i = $index) {
          <input
            [id]="i === 0 ? 'l2fa-digit-0' : null"
            type="text"
            inputmode="numeric"
            maxlength="1"
            autocomplete="one-time-code"
            class="l2fa-digit"
            [class.filled]="digits[i]"
            [value]="digits[i]"
            (input)="onDigitInput(i, $event)"
            (keydown)="onDigitKeydown(i, $event)"
            (paste)="onDigitPaste($event)"
            [disabled]="loading"
          />
        }
      </div>

      <button type="submit" class="l2fa-submit" [disabled]="!isCodeComplete() || loading">
        @if (!loading) {
          <span>Verify &amp; sign in</span>
        } @else {
          <ion-icon name="refresh-outline" class="spin" aria-hidden="true"></ion-icon>
          <span>Verifying…</span>
        }
      </button>
    </form>

    @if (!requiresAuthenticator && showResend) {
      <div class="l2fa-resend">
        <p>Didn't receive the code?</p>
        <button type="button" class="l2fa-resend-btn" (click)="resend.emit()" [disabled]="loading || resendCooldown > 0">
          @if (resendCooldown > 0) {
            Resend in {{ resendCooldown }}s
          } @else {
            Resend code
          }
        </button>
      </div>
    }

    <div class="l2fa-help">
      <ul>
        @if (requiresAuthenticator) {
          <li>Open your authenticator app for the current code</li>
          <li>Codes refresh every 30 seconds</li>
        } @else {
          <li>Check your spam or junk folder</li>
          <li>Codes expire after 10 minutes</li>
        }
        <li>Use the code for this {{ portal === 'seller' ? 'seller' : 'customer' }} login only</li>
      </ul>
    </div>
  </div>
</div>
